import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Eier from './Eier.jsx'
import TinglystEierIcon from '../../../images/Owners 1.png'
import IkkeTinglystEierIcon from '../../../images/Eier ikke tinglyst.png'
import KontaktpersonIcon from '../../../images/Eier kontaktperson.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'


class EierList extends Component {
    state = {
        ikkeTinglysteEiere: [],
        tinglysteEiere: [],
        kontaktinstanser: [],
        skatteregistrerteEiere: [],
        isIkkeTinglysteEiereLoading: false,
        isTinglysteEiereLoading: false,
        isKontaktinstanserLoading: false,
        isSkatteregistrerteEiereLoading: false,
        isIkkeTinglysteEiereOpened: false,
        isTinglysteEiereOpened: false,
        isKontaktinstanserOpened: false,
        isSkatteregistrerteEiereOpened: false,
        tinglysteEiereContinuationToken: null,
        ikkeTinglysteEiereContinuationToken: null,
        kontaktinstanserContinuationToken: null,
        skatteregistrerteEiereContinuationToken: null
    }

    getTinglysteEiere = () => {
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/tinglysteier`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.tinglysteEiereContinuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                tinglysteEiere: [...this.state.tinglysteEiere, ...data.eiere],
                isTinglysteEiereLoading: false,
                tinglysteEiereContinuationToken: data.nextContinuationToken
            })
        })
      }

    getIkkeTinglysteEiere = () => {
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/ikketinglysteier`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.ikkeTinglysteEiereContinuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                ikkeTinglysteEiere: [...this.state.ikkeTinglysteEiere, ...data.eiere],
                isIkkeTinglysteEiereLoading: false,
                ikkeTinglysteEiereContinuationToken: data.nextContinuationToken
            })
        })
      }

    getKontaktinstanser = () => {
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/kontaktinstans`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.kontaktinstanserContinuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                kontaktinstanser: [...this.state.kontaktinstanser, ...data.eiere],
                isKontaktinstanserLoading: false,
                kontaktinstanserContinuationToken: data.nextContinuationToken
            })
        })
      }

    getSkatteregistrerteEiere = () => {
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/skattregistrerteier`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.skatteregistrerteEiereContinuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                skatteregistrerteEiere: [...this.state.skatteregistrerteEiere, ...data.eiere],
                isSkatteregistrerteEiereLoading: false,
                skatteregistrerteEiereContinuationToken: data.nextContinuationToken
            })
        })
      }


      toggleIkkeTinglysteEiere = () => {
          if (this.props.antallIkkeTinglysteEiere == 0) return

        if (this.state.ikkeTinglysteEiere.length == 0) {
            this.setState({isIkkeTinglysteEiereLoading: true})
            this.getIkkeTinglysteEiere()
        }

        this.setState({isIkkeTinglysteEiereOpened: !this.state.isIkkeTinglysteEiereOpened})
    }


    toggleTinglysteEiere = () => {
        if (this.props.antallTinglysteEiere == 0) return

        if (this.state.tinglysteEiere.length == 0) {
            this.setState({isTinglysteEiereLoading: true})
            this.getTinglysteEiere()
        }

        this.setState({isTinglysteEiereOpened: !this.state.isTinglysteEiereOpened})
    }

    toggleKontaktinstanser = () => {
        if (this.props.antallKontaktinstanser == 0) return

        if (this.state.kontaktinstanser.length == 0) {
            this.setState({isKontaktinstanserLoading: true})
            this.getKontaktinstanser()
        }

        this.setState({isKontaktinstanserOpened: !this.state.isKontaktinstanserOpened})
    }

    toggleSkatteregistrerteEiere = () => {
        if (this.props.antallSkatteregistrerteEiere == 0) return

        if (this.state.skatteregistrerteEiere.length == 0) {
            this.setState({isSkatteregistrerteEiereLoading: true})
            this.getSkatteregistrerteEiere()
        }

        this.setState({isSkatteregistrerteEiereOpened: !this.state.isSkatteregistrerteEiereOpened})
    }


    render() {
        const { t } = this.props        
        var antallTinglysteEiere = this.state.tinglysteEiereContinuationToken ? `${this.state.tinglysteEiere.length}/${this.props.antallTinglysteEiere}` : this.props.antallTinglysteEiere
        var antallIkkeTinglysteEiere = this.state.ikkeTinglysteEiereContinuationToken ? `${this.state.ikkeTinglysteEiere.length}/${this.props.antallIkkeTinglysteEiere}` : this.props.antallIkkeTinglysteEiere
        var antallKontaktinstanser = this.state.kontaktinstanserContinuationToken ? `${this.state.kontaktinstanser.length}/${this.props.antallKontaktinstanser}` : this.props.antallKontaktinstanser
        var antallSkatteregistrerteEiere = this.state.skatteregistrerteEiereContinuationToken ? `${this.state.skatteregistrerteEiere.length}/${this.props.antallSkatteregistrerteEiere}` : this.props.antallSkatteregistrerteEiere
        return (
            <React.Fragment>
                { this.props.antallTinglysteEiere > 0 && <React.Fragment>
                    <li>
                        <div className="section-header" onClick={this.toggleTinglysteEiere}>
                            { !this.state.isTinglysteEiereLoading &&
                                <div className="icon-image"><img src={TinglystEierIcon} /></div>
                            }
                            {
                                this.state.isTinglysteEiereLoading &&
                                <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                            }
                            <span className="title">{t('tinglysteeiere')} ({antallTinglysteEiere})</span>
                            <div className="icon-image right"><img className="collapse" src={this.state.isTinglysteEiereOpened ? CollapseIcon : ExpandIcon} /></div>
                        </div>
                        <div className={this.state.isTinglysteEiereOpened && this.state.tinglysteEiere.length > 0 ? "" : "collapsed"}>
                            <ul>
                                { this.state.tinglysteEiere.map((e, index) => {return (<Eier key={e.eierforholdId} eier={e} antall={this.props.antallTinglysteEiere} isLast={index==this.state.tinglysteEiere.length-1} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected}  />)}) }
                                { this.state.tinglysteEiereContinuationToken &&
                                <li key="HentFlere">
                                    <div className="section-header subsection button" onClick={this.getTinglysteEiere}>
                                        <span>{t('hent.eiere')}</span>
                                    </div>
                                </li>
                                }
                            </ul>
                        </div>
                    </li>
                </React.Fragment> }
                { this.props.antallIkkeTinglysteEiere > 0 && <React.Fragment>
                    <li>
                        <div className="section-header" onClick={this.toggleIkkeTinglysteEiere}>
                            { !this.state.isIkkeTinglysteEiereLoading &&
                                <div className="icon-image"><img src={IkkeTinglystEierIcon} /></div>
                            }
                            {
                                this.state.isIkkeTinglysteEiereLoading &&
                                <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                            }
                            <span className="title">{t('ikketinglysteeiere')} ({antallIkkeTinglysteEiere})</span>
                            <div className="icon-image right"><img className="collapse" src={this.state.isIkkeTinglysteEiereOpened ? CollapseIcon : ExpandIcon} /></div>
                        </div>
                        <div className={this.state.isIkkeTinglysteEiereOpened && this.state.ikkeTinglysteEiere.length > 0 ? "" : "collapsed"}>
                            <ul>
                                { this.state.ikkeTinglysteEiere.map((e, index) => {return (<Eier key={e.eierforholdId} eier={e} antall={this.props.antallIkkeTinglysteEiere} isLast={index==this.state.ikkeTinglysteEiere.length-1} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected}  />)}) }
                                { this.state.ikkeTinglysteEiereContinuationToken &&
                                <li key="HentFlere">
                                    <div className="section-header subsection button" onClick={this.getIkkeTinglysteEiere}>
                                        <span>{t('hent.eiere')}</span>
                                    </div>
                                </li>
                                }
                            </ul>
                        </div>
                    </li>
                </React.Fragment> }
                { this.props.antallKontaktinstanser > 0 && <React.Fragment>
                    <li>
                        <div className="section-header" onClick={this.toggleKontaktinstanser}>
                            { !this.state.isKontaktinstanserLoading &&
                                <div className="icon-image"><img src={KontaktpersonIcon} /></div>
                            }
                            {
                                this.state.isKontaktinstanserLoading &&
                                <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                            }
                            <span className="title">{t('kontaktinstanser')} ({antallKontaktinstanser})</span>
                            <div className="icon-image right"><img className="collapse" src={this.state.isKontaktinstanserOpened ? CollapseIcon : ExpandIcon} /></div>
                        </div>
                        <div className={this.state.isKontaktinstanserOpened && this.state.kontaktinstanser.length > 0 ? "" : "collapsed"}>
                            <ul>
                                { this.state.kontaktinstanser.map((e, index) => {return (<Eier key={e.eierforholdId} eier={e} antall={this.props.antallKontaktinstanser} isLast={index==this.state.kontaktinstanser.length-1} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected}  />)}) }
                                { this.state.kontaktinstanserContinuationToken &&
                                <li key="HentFlere">
                                    <div className="section-header subsection button" onClick={this.getKontaktinstanser}>
                                        <span>{t('hent.eiere')}</span>
                                    </div>
                                </li>
                                }
                            </ul>
                        </div>
                    </li>
                </React.Fragment> }
                { this.props.antallSkatteregistrerteEiere > 0 && <React.Fragment>
                    <li>
                        <div className="section-header" onClick={this.toggleSkatteregistrerteEiere}>
                            { !this.state.isSkatteregistrerteEiereLoading &&
                                <div className="icon-image"><img src={IkkeTinglystEierIcon} /></div>
                            }
                            {
                                this.state.isSkatteregistrerteEiereLoading &&
                                <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                            }
                            <span className="title">{t('skatteregistrerteeiere')} ({antallSkatteregistrerteEiere})</span>
                            <div className="icon-image right"><img className="collapse" src={this.state.isSkatteregistrerteEiereOpened ? CollapseIcon : ExpandIcon} /></div>
                        </div>
                        <div className={this.state.isSkatteregistrerteEiereOpened && this.state.skatteregistrerteEiere.length > 0 ? "" : "collapsed"}>
                            <ul>
                                { this.state.skatteregistrerteEiere.map((e, index) => {return (<Eier key={e.eierforholdId} eier={e} antall={this.props.antallSkatteregistrerteEiere} isLast={index==this.state.skatteregistrerteEiere.length-1} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected}  />)}) }
                                { this.state.skatteregistrerteEiereContinuationToken &&
                                <li key="HentFlere">
                                    <div className="section-header subsection button" onClick={this.getSkatteregistrerteEiere}>
                                        <span>{t('hent.eiere')}</span>
                                    </div>
                                </li>
                                }
                            </ul>
                        </div>
                    </li>
                </React.Fragment> }
            </React.Fragment>
        )
    }
}

export default withTranslation('common')(EierList)